module.exports = __webpack_public_path__ + "static/media/isl.4b9edb2c.jpg";